import { useAuth } from '~/contexts'

export const usePermission = (permissions: string[]) => {
  const { authUser } = useAuth()

  const hasPersmission = permissions.every(item => item === authUser?.roles.find(role => role === item))

  return hasPersmission
}
